import { formatIBAN } from "@edaz/utils/bankAccount";
import React from "react";
import { IconType } from "@edaz/edazkit/Icon";
import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import BankTransferViewModel from "../../../viewModels/common/payment/bankTransferViewModel";
import Collapsible from "../collapsible/collapsible";

const SepaInstructions: ViewComponent<BankTransferViewModel> = observer(({ vm }) => {
  const [collapsed, setCollapse] = useState(true);

  const toggle = () => {
    setCollapse(!collapsed);
  };

  function translateLabel(code: string) {
    return vm.translate(`sepaInstructions.labels.${code}`);
  }

  function translateValue(code: string) {
    return vm.translate(`sepaInstructions.values.${code}`);
  }

  return (
    <div className="mt-4 py-2 py-lg-3 border-top border-bottom">
      <Collapsible
        collapsed={collapsed}
        collapse={vm.translate("collapse")}
        toggle={toggle}
        icon={IconType.Euro}
        title={vm.translate("sepaInstructions.title")}>
        <dl className="mb-n2 pt-5 row">
          <div className="col-12">
            <dt>{translateLabel("iban")}</dt>
            <dd className="mb-3">{formatIBAN(vm.chargeOrder.transferPayment.iban, true)}</dd>
          </div>
          <div className="col-12">
            <dt>{translateLabel("swift")}</dt>
            <dd className="mb-3">{translateValue("swift")}</dd>
          </div>
          <div className="col-12">
            <dt>{translateLabel("name")}</dt>
            <dd className="mb-3">{translateValue("name")}</dd>
          </div>
          <div className="col-12 col-lg-6">
            <dt>{translateLabel("address1")}</dt>
            <dd className="mb-3">{translateValue("address1")}</dd>
          </div>
          <div className="col-12 col-lg-6">
            <dt>{translateLabel("address2")}</dt>
            <dd className="mb-3">{translateValue("address2")}</dd>
          </div>
          <div className="col-12 col-lg-6">
            <dt>{translateLabel("country")}</dt>
            <dd className="mb-3">{translateValue("country")}</dd>
          </div>
          <div className="col-12 col-lg-6">
            <dt>{translateLabel("reference")}</dt>
            <dd className="mb-3">{vm.chargeOrder.transferPayment.variableSymbol}</dd>
          </div>
          <div className="col-12 col-lg-6">
            <dt>{translateLabel("message")}</dt>
            <dd className="mb-3">{vm.chargeOrder.transferPayment.variableSymbol}</dd>
          </div>
          <div className="col-12 col-lg-6">
            <dt>{translateLabel("amount")}</dt>
            <dd className="mb-3">{translateValue("amount")}</dd>
          </div>
        </dl>
      </Collapsible>
    </div>
  );
});

export default SepaInstructions;
